import { IPerformanceInvestmentPeriodsObject } from 'services/calculations/financialPerformance/types';

import { IObjectWithId } from 'interfaces/common';

export const getValuesExceptId = (item: IObjectWithId): { [key: string]: unknown } => {
  const entries = Object.entries(item);
  const filteredEntries = entries.filter(([key]) => key !== 'id');
  const result = Object.fromEntries(filteredEntries);

  return result;
};

export function isPerformanceInvestmentPeriodsObject(obj: any): obj is IPerformanceInvestmentPeriodsObject {
  return typeof obj === 'object' && obj !== null && 'y1' in obj && 'y3' in obj && 'y5' in obj;
}
